import { Avatar, Box, Flex, Typography } from "../../ppui";
import { formatToCustomDate } from "../../utils/common";

export const headers = [
  {
    key: "sl_no",
    label: "Sl. No.",
    isVisible: true,
    getValue: (row, index) => (index + 1),
  },
  {
    key: "full_name",
    label: "Name",
    isShortable: true,
    isVisible: true,
    isColumnSticky: "true",
    isClickable: true,
    getValue: (row) => (
        <Flex alignItem="center">
          <Avatar
            className={"avatarHover"}
            size="xs"
            initials={`${row?.employees?.first_name?.trim().substring(0, 1).toUpperCase() || ""}${row?.employees.last_name?.trim().substring(0, 1).toUpperCase() || ""}`}
            color="secondary"
            sx={{ marginInlineEnd: "0.625rem" }}
          />
          <Box color={"secondary"}>
            {row?.employees?.first_name || "--"} {row?.employees?.last_name || "--"}
            <br />
            <Typography color={"default"} colorVariant={"light"} variant={"body3"} mb={"0"}>
              #{row?.employees?.employee_code || "--"}
            </Typography>
          </Box>
        </Flex>
    ),
  },

  {
    key: "gross_salary",
    label: "Gross Salary",
    align: "right",
    isShortable: false,
    isVisible: false,
  },

  {
    key: "loan_amount",
    label: "Loan Amount",
    align: "right",
    isShortable: false,
    isVisible: false,
  },
  {
    key: "monthly_deduction",
    label: "Monthly Deduction",
    align: "right",
    isShortable: false,
    isVisible: false,
  },
  {
    key: "deduction_type",
    label: "Deduction Type",
    align: "left",
    isShortable: false,
    isVisible: false,
  },
  {
    key: "tenure",
    label: "Tenure",
    align: "left",
    isShortable: true,
    isVisible: true,
  },
  {
    key: "loan_issue_date",
    label: "Issue Date",
    align: "left",
    isShortable: true,
    isVisible: true,
    getValue: (row) => formatToCustomDate(new Date(row?.loan_issue_date)),
  },
  // {
  //   key: "dueamount",
  //   label: "Due Amount",
  //   align: "right",
  //   isShortable: true,
  //   isVisible: true,
  // },
  // {
  //   key: "closingdate",
  //   label: "Closing Date",
  //   align: "left",
  //   isShortable: true,
  //   isVisible: true,
  // },
  // {
  //   key: "status",
  //   label: "Status",
  //   align: "left",
  //   isShortable: true,
  //   isVisible: true,
  // },
];

export const rows = [
  {
    slNo: 1,
    name: "Arjun Sharma",
    ecode: "E1011",
    grosssalary: "₹15000",
    deductiontype: "Fixed",
    loanamount: "₹20000",
    monthlydeduction: "₹2000",
    tenure: "2 months",
    loanissuedate: "01-11-2020",
    dueamount: "₹16000",
    closingdate: "01-01-2021",
    status: "Active",
  },
  {
    slNo: 2,
    name: "Priya Singh",
    ecode: "E1022",
    grosssalary: "₹18000",
    deductiontype: "Percentage",
    loanamount: "₹30000",
    monthlydeduction: "₹2500",
    tenure: "3 months",
    loanissuedate: "15-09-2021",
    dueamount: "₹22500",
    closingdate: "15-12-2021",
    status: "Inactive",
  },
  {
    slNo: 3,
    name: "Ravi Kumar",
    ecode: "E1033",
    grosssalary: "₹22000",
    deductiontype: "Fixed",
    loanamount: "₹25000",
    monthlydeduction: "₹2000",
    tenure: "4 months",
    loanissuedate: "23-12-2020",
    dueamount: "₹21000",
    closingdate: "23-04-2021",
    status: "Active",
  },
  {
    slNo: 4,
    name: "Sunita Reddy",
    ecode: "E1044",
    grosssalary: "₹16000",
    deductiontype: "Percentage",
    loanamount: "₹15000",
    monthlydeduction: "₹1500",
    tenure: "2 months",
    loanissuedate: "05-07-2021",
    dueamount: "₹12000",
    closingdate: "05-09-2021",
    status: "Inactive",
  },
  {
    slNo: 5,
    name: "Vikram Patel",
    ecode: "E1055",
    grosssalary: "₹25000",
    deductiontype: "Fixed",
    loanamount: "₹30000",
    monthlydeduction: "₹3000",
    tenure: "5 months",
    loanissuedate: "20-01-2022",
    dueamount: "₹15000",
    closingdate: "20-06-2022",
    status: "Active",
  },
  {
    slNo: 6,
    name: "Anjali Mehta",
    ecode: "E1066",
    grosssalary: "₹20000",
    deductiontype: "Fixed",
    loanamount: "₹10000",
    monthlydeduction: "₹1000",
    tenure: "1 month",
    loanissuedate: "10-03-2021",
    dueamount: "₹9000",
    closingdate: "10-04-2021",
    status: "Inactive",
  },
  {
    slNo: 7,
    name: "Rohan Das",
    ecode: "E1077",
    grosssalary: "₹27000",
    deductiontype: "Percentage",
    loanamount: "₹40000",
    monthlydeduction: "₹3500",
    tenure: "6 months",
    loanissuedate: "28-06-2021",
    dueamount: "₹28000",
    closingdate: "28-12-2021",
    status: "Active",
  },
  {
    slNo: 8,
    name: "Meera Verma",
    ecode: "E1088",
    grosssalary: "₹19000",
    deductiontype: "Fixed",
    loanamount: "₹12000",
    monthlydeduction: "₹1200",
    tenure: "2 months",
    loanissuedate: "11-11-2022",
    dueamount: "₹9600",
    closingdate: "11-01-2023",
    status: "Inactive",
  },
  {
    slNo: 9,
    name: "Suresh Yadav",
    ecode: "E1099",
    grosssalary: "₹23000",
    deductiontype: "Percentage",
    loanamount: "₹35000",
    monthlydeduction: "₹2500",
    tenure: "3 months",
    loanissuedate: "25-04-2023",
    dueamount: "₹25000",
    closingdate: "25-07-2023",
    status: "Active",
  },
  {
    slNo: 10,
    name: "Neha Bansal",
    ecode: "E1100",
    grosssalary: "₹28000",
    deductiontype: "Fixed",
    loanamount: "₹50000",
    monthlydeduction: "₹5000",
    tenure: "10 months",
    loanissuedate: "17-08-2020",
    dueamount: "₹30000",
    closingdate: "17-06-2021",
    status: "Inactive",
  },
];


